/**
 * Created by Christof Sander on 14.02.2017.
 */

/**
 * translate given arguments to string message and return it.
 *
 * @param   args            Arguments[] - arguments of original function call
 * @return  string - printable message
 */
var argsToMessage = function(args){
	var message = '';
	var prefix = '';
	for(var i in args){
		message += prefix;

		try {
			if(typeof(args[i]) === 'function')                                           message += 'function';
			else if(args[i] === null)                                                   message += 'null';
			else if(args[i] instanceof Error)                                           message += args[i].stack || args[i].message || 'UNKOWN ERROR FORMAT';
			else if(args[i] instanceof $.Event)                                         message += 'JQUERY EVENT ' + (args[i].type || 'undefined type') + ' - prevent circular structure error';
			else if(args[i] instanceof Event)                                           message += 'EVENT ' + (args[i].type || 'undefined type') + ' - prevent circular structure error';
			else if(Object.prototype.toString.call(args[i]) === '[object Object]')      message += '<pre>' + JSON.stringify(args[i], null, 2) + '</pre>';
			else if(Object.prototype.toString.call(args[i]) === '[object Array]')       message += '<pre>' + JSON.stringify(args[i], null, 2) + '</pre>';
			else if(
				typeof(args[i]) === 'string' ||
				typeof(args[i]) === 'number' ||
				typeof(args[i]) === 'boolean'
			)                                                                           message += args[i];
			else if(typeof(args[i]) === 'undefined')                                     message += 'UNDEFINED';
			else                                                                        message += 'UNKNOWN TYPE: ' + Object.prototype.toString.call(args[i]);
		} catch(error){
			message += 'DEBUG-CONSOLE-ERROR: ' + (error.stack || error.message || 'UNKNOWN');
		}

		if(i == 0) prefix = ' |<br>';
	}
	return message;
};

/**
 * this module is used to debug by a fallbackConsole (a simple div at the end of the body) instead of the real console.
 * NOTE: this is especially needed for debugging on devices which doesn't support rich debugging features (e.g., ipad).
 *
 * @param appConfig         {} - actual appConfig
 * @param componentList     ComponentList - actual component-list
 * @param $                 jQuery
 */
module.exports = function(appConfig, componentList, $){
	if(appConfig.debug && appConfig.debug.fallbackConsole){
		window.$debugConsole = $(componentList.templates.base_error_debug()).addClass('base_error_debug').click(function(event){
			if($(event.target).closest('button').length > 0){
				window.$debugConsole.hide();
			}
		});
		window.$debugConsoleContent = window.$debugConsole.find('.content');
		window.$debugConsoleButton = $(componentList.templates.base_error_debugButton({ model: { text: 'D', class: 'show' }})).addClass('base_error_debugButton').click(function(event){
			window.$debugConsole.show();
		});
		window.$debugConsoleClearButton = $(componentList.templates.base_error_debugButton({ model: { text: 'C', class: 'clear' }})).addClass('base_error_debugButton').click(function(event){
			window.$debugConsoleContent.html('')
		});
		$('body')
			.append(window.$debugConsole)
			.append(window.$debugConsoleButton)
			.append(window.$debugConsoleClearButton)
		;
		console.log = function(){
			//window.$debugConsole.show();
			window.$debugConsoleContent.prepend('<p class="log">' + argsToMessage(arguments) + '</p>');
		};
		console.error = function(){
			//window.$debugConsole.show();
			window.$debugConsoleContent.prepend('<p class="error">' + argsToMessage(arguments) + '</p>');
		};
		alert = function(){
			window.$debugConsole.show();
			window.$debugConsoleContent.prepend('<p class="alert">' + argsToMessage(arguments) + '</p>');
		};
	}
};
